import { Routes } from '@angular/router';
import { AuthenticationGuard } from '@softline/auth';
import { SOFTLINE_PERMISSION_AI_TABLE_EXTRACTOR } from './ai-table-extractor.shared';
import { JobRepository } from './repositories/job.repository';
import { PlausibilityRepository } from './repositories/plausibility.repository';
import { SupplierProfileRepository } from './repositories/supplier-profile.repository';
import { ExtractionEditService } from './services/extraction-edit.service';
import { ExtractionJobService } from './services/extraction-job.service';
import { ProductMatchService } from './services/product-match.service';
import { SupplierProfileService } from './services/supplier-profile.service';

export const aiTableExtractorRoutes: Routes = [
  {
    path: 'ai-table-extractor',
    canActivate: [AuthenticationGuard],
    data: { permission: SOFTLINE_PERMISSION_AI_TABLE_EXTRACTOR },
    // Scoped to the module route (not per page): the job poll and its state
    // survive the upload → review navigation.
    providers: [
      JobRepository,
      PlausibilityRepository,
      ExtractionJobService,
      ExtractionEditService,
      ProductMatchService,
      SupplierProfileRepository,
      SupplierProfileService,
    ],
    children: [
      { path: '', redirectTo: 'upload', pathMatch: 'full' },
      {
        path: 'upload',
        loadComponent: () =>
          import('./pages/upload/upload.component').then(
            (m) => m.AiTableExtractorUploadComponent
          ),
      },
      {
        path: 'review/:jobId',
        loadComponent: () =>
          import('./pages/review/review.component').then(
            (m) => m.AiTableExtractorReviewComponent
          ),
      },
    ],
  },
];
